export const breadcrumbTitles = {
    collections: 'collections.page.title',
    artists: 'artists.page.title',
    toys: 'toys',
    toy: 'toy.page.digital.toy',
    explore: 'explore.page.title',
    posts: 'posts.page.title',
    create_post: 'post.create.page.title',
    settings: 'settings.page.title',
    sell: 'sell',
    sellers: 'sellers',
    ads: 'ads',
    competition: 'competition',
    subscription: 'subscription',
    'toy-draft': 'toy-draft.page.title',
    withdraw: 'withdraw.page.title',
    history: 'history',
    gold: 'gold',
    ruby: 'ruby',
    generated_codes: 'toy.page.generated.codes.title',
    create_toy: 'create.toy.title',
}
